import { useState, useEffect } from 'react';
import axios from 'axios';

export default () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const [clientId, setClientId] = useState(() => (sessionStorage.getItem('clientId') || localStorage.getItem('clientId') || ''));

  const [isAuth, setIsAuth] = useState(() => {
    const savedClientId = sessionStorage.getItem('clientId') || localStorage.getItem('clientId');
    if (!savedClientId) {
      return false;
    }
    const token = localStorage.getItem(`${savedClientId}_token`);
    const expirationDate = localStorage.getItem(`${savedClientId}_expirationDate`);
    if (!token || !expirationDate) {
      sessionStorage.removeItem('clientId');
      sessionStorage.removeItem('permissions');
      if (localStorage.getItem('clientId') === savedClientId) {
        localStorage.removeItem('clientId');
      }
      return false;
    }
    const expiration = new Date(expirationDate);
    if (
      Number.isNaN(expiration.getTime()) ||
      expiration <= new Date()
    ) {
      localStorage.removeItem(`${savedClientId}_token`);
      localStorage.removeItem(`${savedClientId}_expirationDate`);
      if (localStorage.getItem('clientId') === savedClientId) {
        localStorage.removeItem('clientId');
      }
      sessionStorage.removeItem('clientId');
      sessionStorage.removeItem('permissions');
      return false;
    }
    sessionStorage.setItem('clientId', savedClientId);
    return true;
  });

  useEffect(() => {
    const interceptor = axios.interceptors.request.use(config => {
      const currentClientId = sessionStorage.getItem('clientId');
      if (!currentClientId) {
        return config;
      }
      const token = localStorage.getItem(`${currentClientId}_token`);
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
    return () => {
      axios.interceptors.request.eject(interceptor);
    };
  }, []);

  const login = (token, loginClientId) => {
    const savedClientId = process.env.REACT_APP_LOCAL_DB === 'true' ? 'multivend' : String(loginClientId || '').trim().toLowerCase();
    const expirationDate = new Date(Date.now() + 1000 * 60 * 60).toISOString();
    localStorage.setItem('clientId', savedClientId);
    localStorage.setItem(`${savedClientId}_token`, token);
    localStorage.setItem(`${savedClientId}_expirationDate`, expirationDate);
    sessionStorage.setItem('clientId', savedClientId);
    setClientId(savedClientId);
    setIsAuth(true);
  };

  const logout = async () => {
    if (isLoggingOut || !isAuth) {
      return;
    }
    const currentClientId = sessionStorage.getItem('clientId');
    setIsLoggingOut(true);
    setIsAuth(false);
    setClientId('');
    sessionStorage.removeItem('clientId');
    sessionStorage.removeItem('permissions');
    if (
      currentClientId &&
      localStorage.getItem('clientId') === currentClientId
    ) {
      localStorage.removeItem('clientId');
    }
    window.location.reload();
  };
  return { isAuth, login, logout, clientId, setIsAuth};
};